import { Toaster } from "react-hot-toast";
import { Link } from "react-router-dom";

const Payment = () => {
  return (
    <>
      <Toaster />
      <div>
        <div className="container">
          <div className="grid grid-cols-2 max-md:grid-cols-1 text-black ">
            <div className="my-5">
              <div className="mb-[45px]">
                <h2 className="py-2 font-bold text-[26px] md:text-[30px] sm:text-[26px] lg:text-[34px]">
                  You’re almost there
                </h2>
                <p className="font-bold text-[16px] md:text-[18px] sm:text-[16px] lg:text-[20px]">
                  Now you’ve reviewed your will, follow the steps below to make
                  it legally binding.
                </p>
              </div>
              <div className="mt-5 relative">
                {/* Steps Section */}
                <div className="space-y-6">
                  {/* Step 1 */}
                  <div className="flex items-center gap-5">
                    <div>
                      <button className="w-[60px] sm:w-[80px] h-[60px] sm:h-[80px] rounded-full border-2 border-black text-[20px] sm:text-[30px] font-bold flex justify-center items-center">
                        1
                      </button>
                    </div>
                    <div>
                      <p className="text-[18px] sm:text-[22px] font-bold">
                        Pay for your will
                      </p>
                      <p className="text-sm sm:text-base">
                        Include our update service to benefit from unlimited
                        changes.
                      </p>
                    </div>
                  </div>
                  <div className="w-[1px] ml-[30px] sm:ml-[38px] h-[30px] border-[1px] border-black"></div>

                  {/* Step 2 */}
                  <div className="flex items-center gap-5">
                    <div>
                      <button className="w-[60px] sm:w-[80px] h-[60px] sm:h-[80px] rounded-full border-2 border-black text-[20px] sm:text-[30px] font-bold flex justify-center items-center">
                        2
                      </button>
                    </div>
                    <div>
                      <p className="text-[18px] sm:text-[22px] font-bold">
                        Our experts will check your will
                      </p>
                      <p className="text-sm sm:text-base">
                        We’ll let you know within three days if something needs
                        your attention.
                      </p>
                    </div>
                  </div>
                  <div className="w-[1px] ml-[30px] sm:ml-[38px] h-[30px] border-[1px] border-black"></div>

                  {/* Step 3 */}
                  <div className="flex items-center gap-5">
                    <div>
                      <button className="w-[60px] sm:w-[80px] h-[60px] sm:h-[80px] rounded-full border-2 border-black text-[20px] sm:text-[30px] font-bold flex justify-center items-center">
                        3
                      </button>
                    </div>
                    <div>
                      <p className="text-[18px] sm:text-[22px] font-bold">
                        Sign to make it legally binding
                      </p>
                      <p className="text-sm sm:text-base">
                        Follow the instructions that come with the will to make
                        it official.
                      </p>
                    </div>
                  </div>
                </div>
              </div>
              <div className="flex items-center gap-5 mt-[30px] sm:mt-[50px]">
                <Link to="/make-will-online/subscription/couples">
                  <button className="px-4 py-3 rounded-[5px] bg-primary text-white border-2 border-[#240642] text-[16px] sm:text-[20px] font-bold">
                    Continue
                  </button>
                </Link>
                <a
                  href="/dashboard"
                  className="text-[#b5b5b5] text-[18px] sm:text-[25px] underline"
                >
                  Edit Your Will
                </a>
              </div>
            </div>

            <div className="max-lg:hidden">
              <div className="fixed  right-[6%] w-[500px]  flex justify-center">
                <img
                  src="/assets/images/9.png"
                  alt="wills-guru-logo-white"
                  className="h-full object-cover"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Payment;
